/* eslint-disable no-console */
import React, { useEffect, useState } from 'react'
import { ContentComponentType } from '@splunk-iteng/splunk-shared-components/dist/lib/Types/ContentComponentType'
import { Button } from '@splunk-iteng/splunk-shared-components'
import {
  useDplScreenQuery,
  useRemoveUserDplTableMutation
} from '../../graphql/graphql'
import { formatLocalTimezone } from '../../utils'

export function DplClearComponent({
  currentState,
  doSubmit
}: ContentComponentType) {
  const { email = null } = currentState
  const [submitting, setSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [isError, setIsError] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [clearUser, setClearUser] = useState(false)
  const [dplScreenData, setDplScreenData] = useState(null)
  const [showDplScreen, setShowDplScreen] = useState(false)
  const [removeUserDplTableMutation, { loading }] =
    useRemoveUserDplTableMutation()

  const {
    data = {},
    loading: loadingDplScreen,
    error
  } = useDplScreenQuery({
    variables: { email },
    skip: !doSubmit || !email
  })

  const clearDplUser = () => {
    setClearUser(true)
  }

  useEffect(() => {
    if (loading || loadingDplScreen) {
      setIsLoading(true)
    }
  }, [loading, loadingDplScreen])

  useEffect(() => {
    if ('dplScreen' in data) {
      setIsLoading(false)
      setDplScreenData(data.dplScreen)
      setShowDplScreen(true)
    }
  }, [data])

  useEffect(() => {
    setIsError(error)
  }, [error])

  useEffect(() => {
    setSubmitted(false)
  }, [doSubmit])

  useEffect(() => {
    if (email && clearUser && !submitting && !submitted) {
      setSubmitting(true)
      const submit = async () => {
        await removeUserDplTableMutation({
          variables: {
            username: email
          },
          onError: (err) => {
            setIsError(err)
          }
        })
      }

      submit()
        .then(() => {
          setIsLoading(false)
          setShowDplScreen(false)
          setClearUser(false)
          setSubmitting(false)
          setSubmitted(true)
        })
        .catch((err) => {
          setIsLoading(false)
          setShowDplScreen(false)
          setClearUser(false)
          setSubmitting(false)
          setIsError(err)
        })
    }
  }, [email, clearUser, submitted, removeUserDplTableMutation, submitting])

  if (isLoading) {
    return <div className="p-20">Loading...</div>
  }

  if (isError) {
    let { message } = isError
    if (message.includes('Request failed with status code 404')) {
      message = `${email} was not found on the Denied Persons Table (DPL)`
    } else if (message.includes('Must be in email format')) {
      message = 'Please provide a value with a valid email format'
    }
    return <div className="p-20">{message}</div>
  }

  if (!email && !submitted) {
    return (
      <div className="p-20">Please enter an email to clear from dpl table.</div>
    )
  }

  if (submitting) {
    return <div className="p-20">Clearing user from DPL table...</div>
  }

  if (showDplScreen) {
    const {
      email: mail,
      firstName,
      lastName,
      company,
      country,
      created
    } = dplScreenData

    const found = mail !== ''

    return (
      <div>
        {found ? (
          <div className="pt-20">
            <div>
              <h1 className="text-2xl font-bold">Denied Person Details</h1>
              <h3>First name: {firstName}</h3>
              <h3>Last name: {lastName}</h3>
              <h3>Email: {mail}</h3>
              <h3>Company: {company}</h3>
              <h3>Country: {country}</h3>
              <h3>Flagged: {formatLocalTimezone(created)}</h3>
            </div>
            <Button
              label="Clear"
              formClassName="btn btn-primary"
              currentState={currentState}
              onSubmitCallback={clearDplUser}
            />
          </div>
        ) : (
          <div className="row">
            <div className="col-12">User {mail} is not in the DPL table.</div>
          </div>
        )}
      </div>
    )
  }

  return (
    <div className="row">
      <div className="col-12">
        User {email} was cleared successfully from DPL table
      </div>
    </div>
  )
}
